module.exports = __webpack_public_path__ + "img/a2.c23067e1.svg";